import { ICfa } from "../models/ICfa";
import { ComponentFactory } from "./ComponentFactory";
import { IServiceFactory } from "./IServiceFactory";
import { PrintService } from "./PrintService";

// TODO: We should implement real dependency injection at some point,
// considering https://github.com/microsoft/tsyringe but open to options.
export class ServiceFactory implements IServiceFactory {
	public readonly componentFactory: ComponentFactory;
	public readonly printService: PrintService;

	constructor(app: ICfa) {
		this.componentFactory = new ComponentFactory(app);
		this.printService = new PrintService();
	}
}
